








import {Component, Prop, Vue} from 'vue-property-decorator';
import {ETrackingOrdersStatus} from '@/models/ITrackingOrder';

@Component({})
export default class TrackingOrderStatusLabel extends Vue {
  @Prop({ type: String, required: true }) status: string;

  get color() {
    switch (this.status) {
      case ETrackingOrdersStatus.STATUS_INTRANSIT:
        return 'black';
      case ETrackingOrdersStatus.STATUS_DELIVERED:
        return 'green';
      case ETrackingOrdersStatus.STATUS_UNDELIVERED:
        return 'orange';
      case ETrackingOrdersStatus.STATUS_ALERT:
        return 'pink';
      case ETrackingOrdersStatus.STATUS_NOTFOUND:
        return 'red';
      default:
        return 'black';
    }
  }
}
